<slotcom-navigation-button
  type="close"
  topPosition="1.5"
  (click)="closeDialog()"></slotcom-navigation-button>

<div class="golden-bomb-info-container golden-bomb-info-container-{{ user.culture }}">
  <div class="recurring">
    <div class="recurring-helper">
      <span class="info-text info-text_title">{{ 'home.shop.golden-bomb.info-1' | translate }}</span>
      <span class="info-text info-text_subtitle">{{ 'home.shop.golden-bomb.info-2' | translate }}</span>
    </div>
    <div class="recurring-display">
      <span
        data-testid="slotcom-shop-goldenBombInfo-text"
        class="recurring-text"
        >{{ bombValue | number: '1.0-0' : ('common.culture' | translate) }}</span
      >
      <div class="recurring-coin"></div>
    </div>
    <div class="recurring-helper recurring-helper-6">
      <span
        class="info-text info-text_subtitle info-text_hint"
        [innerHtml]="'home.shop.golden-bomb.hint-text' | translate"></span>
    </div>
  </div>
</div>
